import(/* webpackMode: "eager" */ "/vercel/path1/app/feedback/page.tsx");
